import AppSwitch from 'components/atoms/AppSwitch/AppSwitch'
import {
    TEMPLATE_STATUS,
    TemplateStatus,
    isDraft,
} from 'templates/domain/entities/TemplateStatus'

const SWITCH_STATE_LABELS = {
    on: 'Activa',
    off: 'Inactiva',
} as const

interface DateInfo {
    createdAt: string
    hour: string
}

interface Props {
    created: DateInfo
    updatedAt?: DateInfo
    countRules: number
    chutesAssigned?: {
        totals: number
        notProcessed: number
    }
    isClassification?: boolean
    status?: TemplateStatus
    onStatusChange?: (active: boolean) => void
    updatingStatus?: boolean
    hasActiveOrders?: boolean
}

export default function HeaderPatternDetail({
    created,
    updatedAt,
    chutesAssigned,
    countRules,
    isClassification = false,
    status,
    onStatusChange,
    updatingStatus = false,
    hasActiveOrders = false,
}: Props) {
    const isActive = status === TEMPLATE_STATUS.ACTIVE
    const disabledSwitch = isDraft(status) || updatingStatus || hasActiveOrders

    return (
        <div className="w-full border border-[#E2E8F0] flex justify-between items-start px-4 py-4 bg-white rounded-xl">
            <div className="w-full">
                <p className="text-sm font-normal text-[#475569]">Creada el</p>
                <p className="text-base font-semibold text-[#070A13] mt-1">
                    {created.createdAt}
                </p>
                <p className="text-xs font-normal text-[#475569]">
                    {created.hour} hs
                </p>
            </div>
            {updatedAt && (
                <>
                    <div className="w-px h-16 bg-gray-300 mx-[29px]" />
                    <div className="w-full">
                        <p className="text-sm font-normal text-[#475569]">Última actualización</p>
                        <p className="text-base font-semibold text-[#070A13] mt-1">
                            {updatedAt.createdAt}
                        </p>
                        <p className="text-xs font-normal text-[#475569]">
                            {updatedAt.hour} hs
                        </p>
                    </div>
                </>
            )}
            <div className="w-px h-16 bg-gray-300 mx-[29px]" />
            <div className="w-full">
                <p className="text-sm font-normal text-[#475569]">Reglas</p>
                <p className="text-base font-semibold text-[#070A13] mt-1">
                    {countRules}
                </p>
                <p className="text-xs font-normal text-[#475569]">asignadas</p>
            </div>
            {!isClassification && chutesAssigned && (
                <>
                    <div className="w-px h-16 bg-gray-300 mx-[29px]" />
                    <div className="w-full">
                        <p className="text-sm font-normal text-[#475569]">Chutes asignados</p>
                        <div className="flex gap-8">
                            <div>
                                <p className="text-base font-semibold text-[#070A13] mt-1">{chutesAssigned.totals}</p>
                                <p className="text-xs font-normal text-[#475569]">totales</p>
                            </div>
                            <div>
                                <p className="text-base font-semibold text-[#070A13] mt-1">{chutesAssigned.notProcessed}</p>
                                <p className="text-xs font-normal text-[#475569]">restantes</p>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {status && (
                <>
                    <div className="w-px h-16 bg-gray-300 mx-[29px]" />
                    <div className="w-full">
                        <p className="text-sm font-normal text-[#475569]">Estado</p>
                        <div className="flex items-center gap-1 mt-2">
                            <AppSwitch
                                checked={isActive}
                                onChange={(value) => onStatusChange?.(value)}
                                disabled={disabledSwitch}
                            />
                            <span className={`text-xs font-normal ${disabledSwitch ? 'text-[#CBD5E1]' : 'text-[#475569]'}`}>
                                {isActive ? SWITCH_STATE_LABELS.on : SWITCH_STATE_LABELS.off}
                            </span>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
